const CourseSettingsMenu = [
  {
    heading: "menu",
    route: "/training-program",
    pages: [
      {
        heading: "Add Program",
        route: "/training-program-list/add-program",
        fontIcon: "fas fa-plus fs-3></i>",
        svgIcon: "/media/icons/duotune/arrows/arr013.svg",
      },
      {
        heading: "Advanced Program Report",
        route: "/training-program-list/advanced-program-report",
        fontIcon: "fas fa-road fs-3></i>",
        svgIcon: "/media/icons/duotune/graphs/gra010.svg",
      },
    ],
  },
];

export default CourseSettingsMenu;
